import variables from "@/styles/variables.scss";
import { login } from '@/api/app'
import { setToken, getToken } from '@/utils/auth'
import { getSession } from '@/utils/session'

const state = {
  
}

const mutations = {
 
}

export default {
  namespaced: true,
  state,
  mutations,
}